import { AdminApiService } from '../services';
import type { TaskUpdate } from '../services';

export type GetTasksPayload = {
  sort?: string | null;
  filters?: {
    search?: string | null;
    campaignId?: string | null;
    status?: string | null;
    taskType?: string | null;
    reasoning?: string | null;
    created_from?: string | null;
    created_to?: string | null;
    scheduled_from?: string | null;
    scheduled_to?: string | null;
  };
  page: ApiPaginationType;
};

export const getTasks = ({ filters, sort, page }: GetTasksPayload) => {
  return AdminApiService.getTasksApiAdminTasksGet(
    undefined,
    filters?.campaignId,
    filters?.status,
    undefined,
    filters?.taskType,
    filters?.search,
    filters?.reasoning,
    filters?.created_from,
    filters?.created_to,
    filters?.scheduled_from,
    filters?.scheduled_to,
    sort,
    page?.limit,
    page?.offset
  );
};

export const updateTask = (id: string, payload: TaskUpdate) => {
  return AdminApiService.updateTaskApiAdminTasksTaskIdPatch(id, payload);
};
export const deleteTask = (id: string) => {
  return AdminApiService.deleteTaskApiAdminTasksTaskIdDelete(id);
};

export type { TaskResponse } from '../services';
export type TaskUpdatePayload = TaskUpdate;
